export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-css3-7a8aa3994d7cb94b6aaf251ca43af3ca.svg";